import xhr from '../../utils/xhr';
import utilities from './../../utils/utilities';
import {findIndex} from 'lodash';
import storage from "../../utils/storage";

export const FETCH_ENTITY_SANCTIONS_STARTED = "FETCH_ENTITY_SANCTIONS_STARTED";
export const FETCH_ENTITY_SANCTIONS_RESET = "FETCH_ENTITY_SANCTIONS_RESET";
export const FETCH_ENTITY_SANCTIONS_BATCH_START = "FETCH_ENTITY_SANCTIONS_BATCH_START";
export const FETCH_ENTITY_SANCTIONS_SUCCESS_TOTAL = "FETCH_ENTITY_SANCTIONS_SUCCESS_TOTAL";
export const FETCH_ENTITY_SANCTIONS_SUCCESS_SINGLE = "FETCH_ENTITY_SANCTIONS_SUCCESS_SINGLE";
export const FETCH_ENTITY_SANCTIONS_FAILED = "FETCH_ENTITY_SANCTIONS_FAILED";
export const FETCH_ENTITY_SANCTIONS_FINISHED = "FETCH_ENTITY_SANCTIONS_FINISHED";
export const UPDATE_ENTITY_SANCTIONS_CACHE_FLAG = "UPDATE_ENTITY_SANCTIONS_CACHE_FLAG";

export function resetEntitySanctions() {
    return {
        type: FETCH_ENTITY_SANCTIONS_RESET
    }
}

export function fetchEntitySanctions(entityName, companyId, cisIds = null) {
    return (dispatch, getState) => {
        let fetchState = getState().sanctionsWarnings.singleEntity;
        if (fetchState.isLoading && fetchState.entityName === entityName && cisIds === null) {
            console.log("already loading");
            return;
        }

        // If first call on the entity, query all cisIds no matter what
        if (fetchState.entityName !== entityName) {
            dispatch(fetchEntitySanctionsStarted(entityName, companyId, getState().user.appSettings.cisIDs));
            dispatch(fetchFromCisIds(entityName, getState().user.appSettings.cisIDs));
        } else {
            if (cisIds === null) {
                cisIds = getState().user.appSettings.cisIDs
            }
            dispatch(fetchFromCisIds(entityName, cisIds));
        }
    }
}

export function fetchFromCisIds(entityName, cisIds) {
    return (dispatch, getState) => {
        const fetchState = getState().sanctionsWarnings.singleEntity;
        let promises = [];
        let isFirstRequestBatch = false;
        let currentCisIds = [];

        for (let i = 0 ; i < cisIds.length ; i++) {
            const csId = Object.assign({}, fetchState.cisIDs[findIndex(fetchState.cisIDs, { id: cisIds[i] })]);
            if (cisIds.length === 1 && csId.isLoading) {
                return;
            }
            if (fetchState.totalCount === null) {
                isFirstRequestBatch = true;
            }

            if (csId.start <= csId.totalCount || (csId.totalCount === null)) {
                promises.push(
                    xhr.get({
                        url: `/api/sanctions/company/${entityName}/${cisIds[i]}/${csId.start}/${csId.end}`
                        // url: `/api/sanctions/company/${entityName}/${cisIds[i]}/${csId.start}/${csId.end}`
                        // url: `/sanctions.mock_${entityName}_${cisIds[i]}_${csId.start}_${csId.end}.json`
                    }).then(items => {
                        return items.body;
                    }).catch((error) => {
                        dispatch(fetchEntitySanctionsFailed(cisIds[i]))
                    })
                );
                currentCisIds.push(csId.id)
            }
        }

        dispatch(fetchEntitySanctionsBatchStart(currentCisIds));

        Promise
            .all(promises)
            .then((res) => {
                if (entityName === getState().sanctionsWarnings.singleEntity.entityName) {
                    let entries = [];
                    let totalCount = null;
                    let hasError = false;
                    let hasSanction = false;
                    let auth = storage.getObject("lnei");
                    let isWam = (auth && auth.authInfo && auth.authInfo.type === "WAM");

                    for (let i = 0 ; i < res.length ; i++) {
                        if (res[i]) {
                            totalCount = totalCount + res[i].count;
                            if (isWam === true) {
                                if (res[i].sanctions && res[i].sanctions.length > 0) {
                                    res[i].sanctions = res[i].sanctions.map(sanction => {
                                        let sanctionArticle = utilities.processEsSanctionReport(sanction.html, sanction.title, "pubType", sanction.sourceName, sanction.createdDate, sanction.id);
                                        // let sanctionArticle = sanction;
                                        sanctionArticle.cisID =  res[i].cisID;
                                        sanctionArticle.pcsi = sanction.pcsi;
                                        return sanctionArticle;
                                    });
                                    entries.push(...res[i].sanctions);
                                    dispatch(fetchEntitySanctionsSingleSuccess(res[i].count, res[i].cisID));
                                    hasSanction = true;
                                } else {
                                    if (res[i].count === 0) {
                                        dispatch(fetchEntitySanctionsSingleSuccess(res[i].count, res[i].cisID));
                                    } else if (res[i].failures === true) {
                                        dispatch(fetchEntitySanctionsFailed(currentCisIds[i]));
                                        hasError = true
                                    }
                                }
                            } else {
                                if (res[i].sanctions && res[i].sanctions.length > 0) {
                                    res[i].sanctions = res[i].sanctions.map(sanction => {
                                        let sanctionArticle = utilities.processSanctionReport(sanction.html);
                                        sanctionArticle.cisID =  res[i].cisID;
                                        return sanctionArticle;
                                    });
                                    entries.push(...res[i].sanctions);
                                    dispatch(fetchEntitySanctionsSingleSuccess(res[i].count, res[i].cisID));
                                    hasSanction = true;
                                } else {
                                    if (res[i].count === 0) {
                                        dispatch(fetchEntitySanctionsSingleSuccess(res[i].count, res[i].cisID));
                                    } else if (res[i].failures === true) {
                                        dispatch(fetchEntitySanctionsFailed(currentCisIds[i]));
                                        hasError = true
                                    }
                                }
                            }
                        } else {
                            dispatch(fetchEntitySanctionsFailed(currentCisIds[i]));
                            hasError = true;
                        }
                    }

                    if (isFirstRequestBatch) {
                        if (hasSanction) {
                            dispatch(updateEntitySanctionsCacheFlag(fetchState.companyId, true))
                        } else if (!hasError) {
                            dispatch(updateEntitySanctionsCacheFlag(fetchState.companyId, false))
                        }
                    }

                    dispatch(fetchEntitySanctionsSuccessTotal(fetchState.totalCount > 0 ? fetchState.totalCount : totalCount, entries));
                } else {
                    console.log("=== ignoring out of order Sanctions and Watchlists ===");
                }
            })

        if (!promises.length) {
            dispatch(fetchEntitySanctionsFinished())
        }
    }
}

export function fetchEntitySanctionsStarted(entityName, companyId, cisIDs) {
    return {
        type: FETCH_ENTITY_SANCTIONS_STARTED,
        payload: {
            entityName,
            companyId,
            cisIDs
        }
    }
}

export function fetchEntitySanctionsSuccessTotal(totalCount, items) {
    return {
        type: FETCH_ENTITY_SANCTIONS_SUCCESS_TOTAL,
        payload: {
            totalCount,
            items
        }
    }
}

export function fetchEntitySanctionsSingleSuccess(totalCount, cisId) {
    return {
        type: FETCH_ENTITY_SANCTIONS_SUCCESS_SINGLE,
        payload: {
            totalCount,
            cisId
        }
    }
}

export function fetchEntitySanctionsFailed(cisId = null) {
    return {
        type: FETCH_ENTITY_SANCTIONS_FAILED,
        payload: { cisId }
    }
}

export function fetchEntitySanctionsBatchStart(cisIds) {
    return {
        type: FETCH_ENTITY_SANCTIONS_BATCH_START,
        payload: {
            cisIds
        }
    }
}

export function fetchEntitySanctionsFinished(entityName) {
    return {
        type: FETCH_ENTITY_SANCTIONS_FINISHED
    }
}

export function updateEntitySanctionsCacheFlag(companyId, flag) {
    xhr.put({
        url: `/api/entities/company/${companyId}/update-sanctions-watchlists/${flag}`
    })

    return {
        type: UPDATE_ENTITY_SANCTIONS_CACHE_FLAG,
        payload: {
            flag
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/containers/SanctionsWarnings/SanctionsWarnings.actions.jsx